import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'
import ScrollHint from 'scroll-hint'

import '../src/util/install_sentry'
import 'Components/site/site_footer/component'
import 'Components/site/site_header/component'
import 'Components/site/site_header_navigation/component'
import 'Components/site/company_card/component'
import 'Components/site/call_to_action_link/component'
import 'Components/site/carousel_light/component'
import 'Components/site/review_card/component'
import 'Components/site/latest_high_rate_reviews_widget/component'
import 'Components/site/guide_columns/component'
import 'Components/basics/breadcrumb/component'

import 'Components/site/subsidies/go_to_top/component'
import 'Components/site/subsidies/heading/component'
import 'Components/site/subsidies/heading_from_brackets_to_underline/component'
import 'Components/site/subsidies/accordion_content_with_heading/component'
import 'Components/site/subsidies/terms_section/component'
import 'Components/site/subsidies/receiving_flow_section/component'
import 'Components/site/subsidies/search_by_prefectures/component'
import 'Components/site/subsidies/search_by_construction_parts/component'
import 'Components/site/subsidies/search_by_construction_type/component'
import 'Components/site/subsidies/detail_card/component'
import 'Components/site/subsidies/summary_card/component'
import 'Components/site/subsidies/call_to_action_side_banner/component'

import spToggleNav from '../src/spToggleNav/spToggleNav'
import { setViewHeight } from '../src/subsidies/components/setViewHeight'

window.$ = $

$(() => {
  // スマートフォンのハンバーガーメニュー処理
  spToggleNav()

  // スマホのメニューバーを考慮したvhを利用するために実行
  setViewHeight()
  window.addEventListener('resize', setViewHeight)

  // スマホ時のスクロールヒント表示
  new ScrollHint('.js-scrollHint-target', { i18n: { scrollable: '横スクロール' } })
})
